export const SET_IS_MEMBERTRANSFER_POPUP_OPEN = 'SET_IS_MEMBERTRANSFER_POPUP_OPEN';
export const MEMBERTRANSFER = 'MEMBERTRANSFER';
export const MEMBERSTRANSFER_RESULT = 'MEMBERTRANSFER_RESULT';
